import type { AppState } from '@autoday/core';

/** Even hidden, past or deleted entries signal an existing calendar, not a new user. */
export function hasCalendarContent(state: AppState): boolean {
  return [state.events, state.sourceItems, state.sources, state.templates].some(values => Object.keys(values).length > 0);
}

export function shouldShowLanding(input: { native: boolean; standalone: boolean; guest: boolean; firstRunDone: boolean; hasContent: boolean; hash: string; entryIntent: string | null; entered: boolean }): boolean {
  return !input.native && !input.standalone && input.guest && !input.firstRunDone && !input.hasContent && (!input.hash || input.hash === '#welcome-main') && !input.entryIntent && !input.entered;
}
